import { Building2, UserCheck, Users } from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const FILL_TYPES = {
  OFFICE: { label: 'Office Fill', badge: 'bg-slate-100 text-slate-800 border-slate-300', icon: Building2, description: 'Completed by our office' },
  CLIENT: { label: 'Client Fill', badge: 'bg-amber-50 text-amber-900 border-amber-300', icon: UserCheck, description: 'To be completed by the client' },
  BOTH: { label: 'Office & Client', badge: 'bg-blue-50 text-blue-900 border-blue-300', icon: Users, description: 'Either party may complete' },
};

export const STATUS_COLORS = {
  draft: 'bg-slate-100 text-slate-700',
  link_sent: 'bg-blue-100 text-blue-700',
  viewed: 'bg-purple-100 text-purple-700',
  submitted: 'bg-amber-100 text-amber-700',
  verified: 'bg-emerald-100 text-emerald-700',
  confirmed: 'bg-green-100 text-green-700',
  cancelled: 'bg-red-100 text-red-700',
};

export const STATUS_LABELS = {
  draft: 'Draft',
  link_sent: 'Link Sent',
  viewed: 'Viewed',
  submitted: 'Submitted',
  verified: 'Verified',
  confirmed: 'Confirmed',
  cancelled: 'Cancelled',
};

export const EVENT_LABELS = {
  CREATED: 'Booking created',
  LINK_SENT: 'Link sent to client',
  VIEWED: 'Client opened the form',
  SUBMITTED: 'Client submitted the form',
  RESUBMISSION_REQUESTED: 'Resubmission requested',
  OFFICE_FIELDS_UPDATED: 'Office fields updated',
  VERIFIED: 'Marked verified',
  CONFIRMED: 'Booking confirmed',
  COMPANY_SIGNED: 'Signed on behalf of the company',
  SIGNED_COPY_EMAILED: 'Signed copy emailed to client',
  CANCELLED: 'Booking cancelled',
  FILE_UPLOADED: 'Document uploaded',
};

export const effectiveFilledBy = (section, field) =>
  section?.filled_by === 'OFFICE' ? 'OFFICE' : (field?.filled_by || section?.filled_by || 'CLIENT');

export const isOfficeEditable = (section, field) => effectiveFilledBy(section, field) !== 'CLIENT';

export const resolveAssetUrl = (url) => (!url ? null : url.startsWith('/') ? `${API_URL}${url}` : url);

export const formatValue = (value) => {
  if (value === undefined || value === null || value === '') return '';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return String(value);
};

export const isEmptyValue = (value) =>
  value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0);

export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const validateFieldValue = (field, value) => {
  if (field.required && isEmptyValue(value)) return `Please fill in "${field.label}"`;
  if (isEmptyValue(value)) return null;
  if (field.type === 'email' && !EMAIL_RE.test(String(value).trim())) return `"${field.label}" must be a valid email address (e.g. name@example.com)`;
  if (field.type === 'number') {
    const num = Number(value);
    if (Number.isNaN(num)) return `"${field.label}" must be a number`;
    const v = field.validation || {};
    if (v.min !== undefined && v.min !== null && num < v.min) return `"${field.label}" must be at least ${v.min}`;
    if (v.max !== undefined && v.max !== null && num > v.max) return `"${field.label}" must be at most ${v.max}`;
  }
  return null;
};
